import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormInstanceService } from '../services/form-instance.service';

@Injectable({
    providedIn: 'root'
})
export class PrintableFormInstanceResolver implements Resolve<boolean> {
    constructor(private formInstanceService: FormInstanceService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        return this.loadHtml(state);
    }



    private loadHtml(state: RouterStateSnapshot): Promise<any> {
        let obj = this.getIdAndVersion(state.url);
        let id = obj.id;
        let isVersion = obj.isVersion;
        return this.formInstanceService.getPrintableHtml(id).then(response => {
            return response;
        });
    }

    private getIdAndVersion(url: string): any {
        let ret = {};
        let segments = url.split('/');
        let lastSeg = segments[segments.length - 1].split('?');
        ret['id'] = +lastSeg[0];
        if (lastSeg.length == 2) {
            ret['isVersion'] = lastSeg[1].indexOf('true') > -1; // TODO: clean this up
        }
        return ret;
    }
}
